import { render, staticRenderFns } from "./dash_temp.vue?vue&type=template&id=4f4e46a9&scoped=true"
import script from "./dash_temp.vue?vue&type=script&lang=js"
export * from "./dash_temp.vue?vue&type=script&lang=js"
import style0 from "./dash_temp.vue?vue&type=style&index=0&id=4f4e46a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4e46a9",
  null
  
)

export default component.exports